import { Outlet } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { SessionProvider } from './context/session-provider';
import { WorkspaceProvider } from './context/workspace-provider';

const queryClient = new QueryClient();

const Providers = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <SessionProvider>
        <WorkspaceProvider>
          <div className="bg-bg-main min-h-screen">
            <Outlet />
          </div>
        </WorkspaceProvider>
      </SessionProvider>
    </QueryClientProvider>
  );
};

export default Providers;
